function getEnvironment() {
  return document.body.getAttribute('data-env')
}

export function inTestEnvironment() {
  return getEnvironment() === 'test'
}
